export const Spacing = [
  0, 2, 4, 6, 8, 10, 12, 16, 20, 24, 32, 40, 44, 48, 52, 56, 64, 72, 80, 96,
  120,
] as const;

export type TSpacing = (typeof Spacing)[number];

/** This seemingly useless function forces you to use one of the predetermined spacing values,
 * and returns with the 'px' concatenated
 *
 * example: `Space(4) => '4px'`
 * */
export const Space = (size: TSpacing) => `${size}px`;
